import getFeatureFlagClient from '@sdk/featureFlags/launchdarkly';
import { LdFeatureFlags } from '@sdk/featureFlags/types';
import type { GetIntercomBootSettingsFlags } from 'sling-sdk/src/intercom/getIntercomBootSettings';

/**
 * Builds flags for `getIntercomBootSettings` from the web LaunchDarkly client.
 * @param orgId - Optional organization ID to use as context for targeting
 */
export async function getIntercomBootSettingsFlags(
  orgId?: number
): Promise<GetIntercomBootSettingsFlags> {
  const ldClient = await getFeatureFlagClient();
  let intercomToastEnabled = true;
  let alwaysCallIntercomEndpoint = false;

  if (orgId) {
    intercomToastEnabled =
      (await ldClient?.isFeatureEnabledForContext?.(
        LdFeatureFlags.INTERCOM_TOAST_ENABLED,
        { key: String(orgId) },
        true
      )) ?? true;
    alwaysCallIntercomEndpoint =
      (await ldClient?.isFeatureEnabledForContext?.(
        LdFeatureFlags.INTERCOM_ALWAYS_MAKE_USER_CALL_ENABLED,
        { key: String(orgId) },
        false
      )) ?? false;
  } else {
    intercomToastEnabled =
      ldClient?.isFeatureEnabled?.(LdFeatureFlags.INTERCOM_TOAST_ENABLED, true) ?? true;
    alwaysCallIntercomEndpoint =
      ldClient?.isFeatureEnabled?.(LdFeatureFlags.INTERCOM_ALWAYS_MAKE_USER_CALL_ENABLED, false) ??
      false;
  }

  return {
    intercomToastEnabled,
    alwaysCallIntercomEndpoint,
  };
}
